const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUUID(value: string): boolean {
  return UUID_PATTERN.test(value);
}

function normalizeEntries(entries: unknown[]): string[] {
  return Array.from(
    new Set(
      entries
        .map((entry) => String(entry ?? '').trim())
        .filter((entry) => entry.length > 0)
    )
  );
}

export function parseCommaSeparatedValues(value: unknown): string[] {
  if (value === null || value === undefined) {
    return [];
  }

  if (Array.isArray(value)) {
    return normalizeEntries(value);
  }

  if (typeof value !== 'string') {
    return [];
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return [];
  }

  if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        return normalizeEntries(parsed);
      }
    } catch {
      // fall through to comma parsing
    }
  }

  const normalized = trimmed.replace(/[\n\r;]+/g, ',');
  return normalizeEntries(normalized.split(','));
}

export function formatCommaSeparatedValues(values: string[]): string | null {
  if (!values.length) {
    return null;
  }

  const uniqueValues = Array.from(
    new Set(values.map((entry) => entry.trim()).filter(Boolean))
  );

  if (!uniqueValues.length) {
    return null;
  }

  return uniqueValues.join(', ');
}
